<script lang="ts" setup>
import WokProductSelect from '@/components/Wok/WokProductSelect.vue'

const props = defineProps({
  description: {
    type: String,
    required: false,
    default: null,
  },
  numberCategory: {
    type: Number,
    required: true,
  },
  name: {
    type: String,
    required: false,
    default: null,
  },
  currency: {
    type: String,
    required: true,
  },
  products: {
    type: Array,
    required: true,
  },
  value: {
    type: Number,
    required: false,
    default: null,
  },
})

const emits = defineEmits(['input'])

const selectProduct = (id: number) => {
  emits('input', props.name, id)
}
</script>

<template>
  <div class="category">
    <h2 v-if="name" class="category__name">
      {{ `${numberCategory + 1} ${name}` }}
    </h2>

    <div v-if="description" class="category__description">
      {{ description }}
    </div>

    <wok-product-select
      :value="value"
      :products="products"
      :currency="currency"
      @input="selectProduct"
    />
  </div>
</template>

<style lang="scss" scoped>
.category {
  &__name {
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 800;
    color: var(--ui-text-primary);

    @include media('>=desktop-mini') {
      margin-bottom: 30px;
      color: #373b4d;
    }
  }

  &__description {
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 500;
    color: var(--ui-dark-grey);

    @include media('>=desktop-mini') {
      margin-bottom: 50px;
      font-size: 16px;
    }
  }
}
</style>
